module.exports = __webpack_public_path__ + "img/丝路文博网_04.faa56c19.jpg";